import './DropDown.css';

type DropDownProps = {
  options: string[];
  value: string;
  onChange: (value: string) => void;
  defaultValue: string;
  id: string;
};

export function DropDown({ options, value, onChange, defaultValue, id }: DropDownProps) {
  const handleChange = (event) => {
    onChange(event.target.value);
  };

  return (
    <div className="profile rdrop_down_wrapper">
      <div className="custom_select" tabIndex={-1}>
        <select value={value} onChange={handleChange} id={id} aria-labelledby={`${id}-legend`}>
          <option disabled value="" className="disabled" tabIndex={-1}>
            {defaultValue}
          </option>
          {options?.map((item, index) => (
            <option key={index} id={`${id}-${index}`} value={item} className="r_drop_down_content">
              {item}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
